import _extends from 'babel-runtime/helpers/extends';
import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';

import _ from 'lodash';
import SearchBar from '@/components/SearchV3/index.vue';
import searchMixin from '@/mixin/search';
import TableList from '@/components/TableList/index.vue';
import AuthorizeDialog from './authorize-dialog/index.vue';
import AuthorizeConfigDialog from './authorize-config-dialog/index.vue';
import UpdateCreditDialog from './update-credit-dialog/index.vue';
import ExtraDialog from './extra-dialog/index.vue';
import UpgradeDialog from './upgrade-dialog/index.vue';
import RevokeDialog from './revoke-dialog/index.vue';
import Pagination from '@/components/Pagination/index.vue';
import { fetchGrantList, fetchGrantPlans, grantBalanceList } from '@/api/grant/grant';
import { format } from 'date-fns';
import { statusList, authStatusList, testList } from '@/views/producer/common-template/selling-strategy.js';
import { v2Host } from '@/config/host';
import { downloadWithNewWindow } from '@/common/download.js';
import { cookRequestParams } from '@/common/request';
import {
// PermissionKey,
GrantTypeLabel, PlanScopeLabel, statusOptions, GrantType, PlanNormal, PlanType } from '@/common/permission';
import qs from 'qs';
import { getTotalAmount, getMaxAmount } from './utils';
import AuthorizeFilterList from './mixin/authorize-filter-list';
import ListTooltipCell from './components/list-tooltip-cell.vue';
import { fmtThousands } from '@com/utils/data-format';

export default {
  components: {
    SearchBar: SearchBar,
    TableList: TableList,
    AuthorizeDialog: AuthorizeDialog,
    AuthorizeConfigDialog: AuthorizeConfigDialog,
    ExtraDialog: ExtraDialog,
    Pagination: Pagination,
    UpgradeDialog: UpgradeDialog,
    RevokeDialog: RevokeDialog,
    UpdateCreditDialog: UpdateCreditDialog,
    ListTooltipCell: ListTooltipCell
  },
  mixins: [searchMixin, AuthorizeFilterList],
  data: function data() {
    return {
      listLoading: true,
      query: {
        page: 1,
        page_size: 15,
        adv_id: '',
        adv_ids: [],
        template_ids: [],
        channel_ids: [],
        status: '',
        account_type: '',
        subscribe_type: '',
        free: '', // 1是 2否 0全部
        is_test: ''
      },
      // templateList: [],
      planList: [],
      pagination: {
        total: 0
      },
      // optionChannels: [],
      // 表单数据
      list: [],
      currentAuthorizeInfo: {},
      addDialog: {
        visible: false
      },
      configDialog: {
        visible: false
      },
      extraDialog: {
        visible: false
      },
      updateDialog: {
        visible: false
      },
      revokeDialog: {
        visible: false
      },
      updateCreditDialog: {
        visible: false
      },
      subscribeTypes: [],
      demoMaxPushCount: 0,
      actions: [{
        title: '配置',
        action: this.handleConfigDialog,
        display: this.checkDisplay,
        latchkey: 'grant.list'
      }, {
        title: '修改<br />授权',
        action: this.handleAuthDialog,
        display: this.checkDisplay,
        latchkey: 'grant.update'
      }, {
        title: '额外<br />购买',
        action: this.handleExtraDialog,
        display: this.checkDisplay,
        latchkey: 'grant.supplement'
      }, {
        title: '升级<br />套餐',
        action: this.handleUpdateDialog,
        display: this.checkDisplay,
        latchkey: 'grant.upgrade'
      }, {
        title: '关闭<br />授权',
        action: this.handleCloseDialog,
        display: this.checkDisplay,
        latchkey: 'grant.revoke'
      }, {
        title: '最低<br />余额',
        action: this.handleUpdateCreditDialog,
        display: this.checkDisplay,
        latchkey: 'grant.update-credit'
      }],
      statusOptions: statusOptions,
      GrantType: GrantType
    };
  },

  computed: {
    exportButtonAttrs: function exportButtonAttrs() {
      return {
        icon: 'el-icon-fa-download',
        type: 'primary'
      };
    },
    tableColumnConfig: function tableColumnConfig() {
      return this.getTableColumnConfig('adv');
    },
    authTableColumnConfig: function authTableColumnConfig() {
      return this.getTableColumnConfig('auth');
    }
  },
  watch: {
    $route: function $route(to, from) {
      if (this.query.template_ids.length) {
        this.setTemplateInitData();
      }
      if (this.query.channel_ids.length) {
        this.query.channel_ids = this.query.channel_ids.map(function (val) {
          return val.toString();
        });
      }
      if (this.query.admin_ids.length) {
        this.query.admin_ids = this.query.admin_ids.map(function (val) {
          return val.toString();
        });
      }
      this.getGrantList(this.query);
    }
  },
  methods: {
    checkDisplay: function checkDisplay(row, key) {
      switch (key) {
        case 'grant.update':
          return row.grant_type === GrantType.Normal && (row.status === 'active' || row.status === 'unactive');
        case 'grant.revoke':
          return row.status === 'active';
        case 'grant.supplement':
          return row.grant_type === GrantType.Normal && (row.status === 'active' || row.status === 'unactive');
        case 'grant.update-credit':
          return row.plan_type === PlanType.Recharge;
        case 'grant.upgrade':
          if (row.plan_type === PlanType.Recharge) {
            return false;
          }

          return row.grant_type === GrantType.Normal && row.plan_id !== PlanNormal.planA && row.plan_id !== PlanNormal.planB;
        default:
      }

      return true;
    },
    getStatusLabel: function getStatusLabel(status, type) {
      var list = type === 'auth' ? authStatusList : statusList;
      var temp = list.filter(function (item) {
        return item.value === status;
      });
      if (temp.length) {
        return temp[0].label;
      }
      return '-';
    },
    setTemplateInitData: function setTemplateInitData() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.getTemplateList({
                  ids: _this.query.template_ids
                });

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    getGrantList: function getGrantList(params) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var res;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.listLoading = true;
                _context2.next = 3;
                return fetchGrantList(_extends({}, params, {
                  free: !params.free ? 0 : params.free
                }));

              case 3:
                res = _context2.sent;

                _this2.listLoading = false;

                if (!(res.status !== 200)) {
                  _context2.next = 8;
                  break;
                }

                _this2.$message.error('出错了');
                return _context2.abrupt('return');

              case 8:
                _this2.list = _this2.cookList(res);
                _this2.pagination.total = _.get(res, 'data.data.total');

              case 10:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    exportSheet: function exportSheet() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                try {
                  downloadWithNewWindow(v2Host + '/grant/export?' + qs.stringify(cookRequestParams(_this3.query)));
                } catch (error) {
                  console.log(error);
                }

              case 1:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    handleConfigDialog: function handleConfigDialog(item) {
      this.configDialog.visible = true;
      this.currentAuthorizeInfo = item;
    },
    getTableColumnConfig: function getTableColumnConfig(type) {
      var _this4 = this;

      // const parseNum = (num) => {
      //   if (num === -1) {
      //     return '无限量'
      //   } else if (num > 0) {
      //     return num.toLocaleString()
      //   }
      //   return '-'
      // }
      var _default = [{
        label: '授权ID',
        prop: 'id',
        width: 80,
        fixed: 'left'
      }, {
        label: '广告主ID',
        prop: 'adv_id',
        width: 120,
        fixed: 'left'
      }, {
        label: '广告主名称',
        prop: 'adv_name',
        width: 130,
        fixed: 'left'
      }, {
        label: '订阅类型',
        prop: 'grant_type',
        params: {
          innerHTML: function innerHTML(_ref) {
            var row = _ref.row;

            return GrantTypeLabel[row.grant_type] || '';
          }
        }
      }, {
        label: '授权范围',
        prop: 'plan_scope',
        params: {
          innerHTML: function innerHTML(_ref2) {
            var row = _ref2.row;

            return PlanScopeLabel[row.plan_scope] || '';
          }
        }
      }, {
        label: '套餐名称',
        prop: 'plan_name',
        width: 160
      }, {
        label: '主套餐ID',
        prop: 'plan_id'
      }, {
        label: '授权状态',
        prop: 'status',
        width: 100,
        params: {
          innerHTML: function innerHTML(_ref3) {
            var row = _ref3.row;

            return _this4.statusOptions[row.status] || '';
          }
        }
      }, {
        label: '授权功能',
        prop: 'permission_names',
        width: 200
      }, {
        label: '是否测试账号',
        prop: 'is_test',
        width: 100,
        params: {
          innerHTML: function innerHTML(_ref4) {
            var row = _ref4.row;

            var temp = testList.find(function (s) {
              return s.value === row.is_test;
            });
            return temp ? temp.label : '-';
          }
        }
      }, {
        label: '重置周期（天）',
        prop: 'reset_day',
        params: {
          innerHTML: function innerHTML(_ref5) {
            var row = _ref5.row;

            return row.reset_day ? row.reset_day + '天' : '-';
          }
        }
      }, {
        label: '可玩MTG是否计费',
        prop: 'mtg_charge',
        params: {
          innerHTML: function innerHTML(_ref6) {
            var row = _ref6.row;

            if (row.mtg_charge) {
              return row.mtg_charge === 1 ? '是' : '否';
            }
            return '-';
          }
        }
      }, {
        prop: 'template_names',
        slot: 'template-cell'
      }, {
        label: '可玩额度（条/周期）',
        prop: 'download_push',
        width: 140,
        params: {
          innerHTML: function innerHTML(_ref7) {
            var row = _ref7.row;

            var value = getTotalAmount(row, 'download_push');
            return value || '-';
          }
        }
      }, {
        label: '视频额度（点/周期）',
        prop: 'video_credits',
        width: 140,
        params: {
          innerHTML: function innerHTML(_ref8) {
            var row = _ref8.row;

            var value = getTotalAmount(row, 'video_credits');
            return value || '-';
          }
        }
      }, {
        prop: 'channel_names',
        slot: 'channel-cell'
      }, {
        label: '总存储空间（G）',
        prop: 'total_storage',
        width: 120,
        params: {
          innerHTML: function innerHTML(_ref9) {
            var row = _ref9.row;

            return getMaxAmount(row, 'storage');
          }
        }
      }, {
        label: '总在线人数',
        prop: 'total_online',
        width: 100,
        params: {
          innerHTML: function innerHTML(_ref10) {
            var row = _ref10.row;

            return getTotalAmount(row, 'online');
          }
        }
      }, {
        label: '授权生效时间',
        prop: 'effective_time',
        width: 140
      }, {
        label: '授权到期时间',
        prop: 'expired_time',
        width: 140
      }, {
        label: '授权天数',
        prop: 'days',
        width: 80,
        params: {
          innerHTML: function innerHTML(_ref11) {
            var row = _ref11.row;

            return row.days ? row.days + '天' : '-';
          }
        }
      }, {
        label: '授权更新时间',
        prop: 'reset_time',
        width: 140
      }, {
        label: '总付费金额',
        prop: 'revenue',
        width: 120,
        params: {
          innerHTML: function innerHTML(_ref12) {
            var row = _ref12.row;

            if (typeof row.revenue === 'number') {
              return row.revenue === 0 ? '免费（0）' : '\u4ED8\u8D39\uFF08' + row.revenue + '\uFF09';
            }
            return '-';
          }
        }
      }, {
        label: '最低余额',
        prop: 'credit_amount',
        params: {
          innerHTML: function innerHTML(_ref13) {
            var row = _ref13.row;

            return row.plan_type === PlanType.Recharge ? fmtThousands(row.credit.min_amount) : '-';
          }
        }
      }, {
        label: '单价',
        prop: 'unit_price',
        params: {
          innerHTML: function innerHTML(_ref14) {
            var row = _ref14.row;

            if (row.unit_price) {
              return row.plan_id === PlanNormal.planCPM ? '$' + row.unit_price : row.unit_price + '%';
            }
            return '-';
          }
        }
      },
      // {
      //   label: '价格上限',
      //   prop: 'max_service_fee',
      //   params: {
      //     innerHTML({ row }) {
      //       if (
      //         row.plan_type === PlanType.Recharge &&
      //         row.max_service_fee !== 0
      //       ) {
      //         return row.max_service_fee === -1
      //           ? '不限制'
      //           : '$' + row.max_service_fee
      //       }
      //       return '-'
      //     },
      //   },
      // },
      {
        label: '停止计费方式',
        prop: 'stop_bill_method'
      }, {
        label: '渠道cap',
        prop: 'channel_max_price',
        params: {
          innerHTML: function innerHTML(_ref15) {
            var row = _ref15.row;

            if (row.plan_type === PlanType.Recharge && row.channel_max_price > 0) {
              return fmtThousands(row.channel_max_price);
            }
            return '-';
          }
        }
      }, {
        label: '全渠道cap',
        prop: 'creative_max_price',
        params: {
          innerHTML: function innerHTML(_ref16) {
            var row = _ref16.row;

            if (row.plan_type === PlanType.Recharge && row.creative_max_price > 0) {
              return fmtThousands(row.creative_max_price);
            }
            return '-';
          }
        }
      }, {
        label: '渠道buyout',
        prop: 'channel_buyout_price',
        params: {
          innerHTML: function innerHTML(_ref17) {
            var row = _ref17.row;

            if (row.plan_type === PlanType.Recharge && row.channel_buyout_price > 0) {
              return fmtThousands(row.channel_buyout_price);
            }
            return '-';
          }
        }
      }, {
        label: '全渠道buyout',
        prop: 'creative_buyout_price',
        params: {
          innerHTML: function innerHTML(_ref18) {
            var row = _ref18.row;

            if (row.plan_type === PlanType.Recharge && row.creative_buyout_price > 0) {
              return fmtThousands(row.creative_buyout_price);
            }
            return '-';
          }
        }
      }, {
        label: '合同编码',
        prop: 'contract_code'
      }, {
        label: '最后操作时间',
        prop: 'updated_time'
      }, {
        label: '最后操作人',
        prop: 'admin_name'
      }, {
        label: '备注',
        slot: 'reason'
      }, {
        slot: 'action-cell'
      }];

      return _default;
    },
    getPlanList: function getPlanList() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var res;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return fetchGrantPlans({
                  // grant_type: this.formValue.grant_type,
                });

              case 2:
                res = _context4.sent;


                _this5.planList = (_.get(res, 'data.data') || []).map(function (item) {
                  return _extends({}, item, {
                    value: item.id,
                    label: item.name
                  });
                });

              case 4:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this5);
      }))();
    },
    showAddDialog: function showAddDialog() {
      this.currentAuthorizeInfo = {};
      this.addDialog.visible = true;
    },
    handleAuthDialog: function handleAuthDialog(item) {
      this.currentAuthorizeInfo = item;
      this.addDialog.visible = true;
    },
    handleExtraDialog: function handleExtraDialog(item) {
      this.currentAuthorizeInfo = item;
      this.extraDialog.visible = true;
    },
    handleUpdateDialog: function handleUpdateDialog(item) {
      this.currentAuthorizeInfo = item;
      this.updateDialog.visible = true;
    },
    handleCloseDialog: function handleCloseDialog(item) {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var params, res, balanceList;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!(item.plan_type === PlanType.Recharge)) {
                  _context5.next = 15;
                  break;
                }

                params = {
                  adv_id: item.adv_id,
                  page: 1,
                  page_size: 15
                };
                _context5.prev = 2;
                _context5.next = 5;
                return grantBalanceList(params);

              case 5:
                res = _context5.sent;
                balanceList = _.get(res, 'data.data.list') || [];

                // 客户账户余额为0才能关闭授权

                if (balanceList.length > 0 && balanceList[0].balance === 0) {
                  _this6.currentAuthorizeInfo = item;
                  _this6.revokeDialog.visible = true;
                } else {
                  _this6.$message.error('当前客户账户余额不为零，无法关闭授权，请先联系财务处理。');
                }
                _context5.next = 13;
                break;

              case 10:
                _context5.prev = 10;
                _context5.t0 = _context5['catch'](2);

                console.log(_context5.t0);

              case 13:
                _context5.next = 17;
                break;

              case 15:
                _this6.currentAuthorizeInfo = item;
                _this6.revokeDialog.visible = true;

              case 17:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this6, [[2, 10]]);
      }))();
    },
    handleUpdateCreditDialog: function handleUpdateCreditDialog(item) {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _this7.currentAuthorizeInfo = item;
                _this7.updateCreditDialog.visible = true;

              case 2:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this7);
      }))();
    },
    cookList: function cookList(res) {
      var list = (_.get(res, 'data.data.list') || []).map(function (item) {
        return _extends({}, item, {
          updated_time: format(item.updated_time * 1000, 'YYYY-MM-DD HH:mm:ss'),
          reset_time: item.reset_time ? format(item.reset_time * 1000, 'YYYY-MM-DD HH:mm:ss') : '-',
          effective_time: item.effective_time ? format(item.effective_time * 1000, 'YYYY-MM-DD HH:mm:ss') : '-',
          created_time: format(item.created_time * 1000, 'YYYY-MM-DD HH:mm:ss'),
          expired_time: item.expired_time ? format(item.expired_time * 1000, 'YYYY-MM-DD HH:mm:ss') : '-',
          template_ids: item.template_ids === '-1' ? '' : item.template_ids,
          channel_ids: item.channel_ids === '-1' ? '' : item.channel_ids,
          plan_settings: item.plan_settings ? item.plan_settings : {}
        });
      });

      return list;
    },
    handleSaveAuthorizeSuccess: function handleSaveAuthorizeSuccess() {
      this.getGrantList(this.query);
    },
    getPackageConfig: function getPackageConfig() {
      var _this8 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        var res;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;
                _context7.next = 3;
                return _this8.$store.dispatch('config/getGrantConfig');

              case 3:
                res = _context7.sent;

                _this8.subscribeTypes = _.get(res, 'subscribe_types');
                _this8.demoMaxPushCount = _.get(res, 'trial_account_max_push_count');
                _context7.next = 11;
                break;

              case 8:
                _context7.prev = 8;
                _context7.t0 = _context7['catch'](0);

                console.log(_context7.t0);

              case 11:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this8, [[0, 8]]);
      }))();
    },
    handleReload: function handleReload() {
      this.getGrantList(this.query);
    },
    getOptionChannels: function getOptionChannels() {
      var _this9 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        var useCache, res;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                useCache = true;
                _context8.next = 3;
                return _this9.$store.dispatch('config/getCommonConfig', {
                  useCache: useCache,
                  names: ['channels']
                });

              case 3:
                res = _context8.sent;

                _this9.optionChannels = [{
                  id: '-1',
                  value: '-1',
                  label: '全部'
                }].concat((_.get(res, 'channels') || []).map(function (item) {
                  return _extends({}, item, {
                    value: item.id.toString(),
                    label: item.name
                  });
                }));

              case 5:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, _this9);
      }))();
    },
    renderPermissionLabel: function renderPermissionLabel(row, key) {
      var permissions = row.permissions.split(',');
      return permissions.includes(key) ? 'Yes' : 'No';
    }
  },

  mounted: function mounted() {
    var _this10 = this;

    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
      return _regeneratorRuntime.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 2;
              return _this10.getPackageConfig();

            case 2:
              _this10.getGrantList(_this10.query);
              _this10.setTemplateInitData();
              _this10.getOptionChannels();
              _this10.getPlanList();
              _this10.getOperator();

            case 7:
            case 'end':
              return _context9.stop();
          }
        }
      }, _callee9, _this10);
    }))();
  }
};